import { AuthenticationProvider } from "@/common/providers/authentication";
import { Navigate, RouteObject, useLocation } from "react-router-dom";
import { User } from "../authentication/models/user";
import GiveawayDetailsPage from "../giveaways/pages/giveaway-details";
import GiveawaysPage from "../giveaways/pages/giveaways";
import LegalInformationRoute from "../legal-information/route";
import MerchPage from "../merch/pages/merch";
import MerchCartPage from "../merch/pages/cart";
import MerchProductPage from "../merch/pages/product";
import BecomeAPartnerPage from "../partners/pages/become-a-partner";
import CheckoutPage from "../payments/pages/checkout";
import {
	CheckoutCartRoute,
	CheckoutEntryRoute,
	CheckoutPlanRoute,
} from "../payments/route";
import ProfileRoute from "../profile/route";
import WinnersPage from "../winners/pages/winners";
import LayoutPage from "./containers/layout";
import AboutUsPage from "./pages/about-us";
import FaqsPage from "./pages/faqs";
import HomePage from "./pages/home";

function LegacyMerchRedirect() {
	const location = useLocation();
	const nextPath = location.pathname.replace(/^\/merch/, MerchRoute);
	return <Navigate to={`${nextPath}${location.search}${location.hash}`} replace />;
}

function layoutLoader() {
	const user = window.localStorage.getItem("user");

	if (!user) {
		return;
	}

	const navUser = JSON.parse(user) as User;

	if (!navUser || !navUser.emailVerified) {
		return;
	}

	AuthenticationProvider.signin(navUser);
	return { user: AuthenticationProvider.user };
}

const RootRoute = "/";
export const HomeRoute = RootRoute + "home";
export const AboutUsRoute = RootRoute + "about-us";
export const BecomeAPartnerRoute = RootRoute + "become-a-partner";
export const GiveawaysRoute = RootRoute + "giveaways";
export const GiveawayDetailsRoute = GiveawaysRoute + "/details";
export const MerchRoute = RootRoute + "store";
export const MerchCartRoute = MerchRoute + "/cart";
export const MerchProductRoute = MerchRoute + "/:slug";
export const WinnersRoute = RootRoute + "winners";
export const FAQsRoute = RootRoute + "faqs";

const route: RouteObject = {
	id: "root",
	path: RootRoute,
	loader: layoutLoader,
	Component: LayoutPage,
	children: [
		{
			index: true,
			element: <Navigate to={HomeRoute} replace />,
		},
		{
			path: HomeRoute,
			Component: HomePage,
		},
		{
			path: AboutUsRoute,
			Component: AboutUsPage,
		},
		{
			path: BecomeAPartnerRoute,
			Component: BecomeAPartnerPage,
		},
		{
			path: "/merch/*",
			Component: LegacyMerchRedirect,
		},
			{
				path: GiveawaysRoute,
				children: [
					{
						index: true,
						Component: GiveawaysPage,
					},
					{
						path: GiveawayDetailsRoute,
						Component: GiveawayDetailsPage,
					},
				],
			},
			{
				path: MerchRoute,
				children: [
					{
						index: true,
						Component: MerchPage,
					},
					{
						path: MerchCartRoute,
						Component: MerchCartPage,
					},
					{
						path: MerchProductRoute,
						Component: MerchProductPage,
					},
				],
			},
		{
			path: CheckoutEntryRoute,
			Component: CheckoutPage,
		},
		{
			path: CheckoutPlanRoute,
			Component: CheckoutPage,
		},
		{
			path: CheckoutCartRoute,
			Component: CheckoutPage,
		},
		{
			path: WinnersRoute,
			Component: WinnersPage,
		},
		{
			path: FAQsRoute,
			Component: FaqsPage,
		},
		ProfileRoute,
		LegalInformationRoute,
	],
};

export default route;
